import React from 'react'

import { styled } from '@linaria/react'

import eyeWithKeyholeSvg from 'components/designSystem/svg/eye-with-keyhole.svg'

export const IncognitoCover = () => {
  return (
    <IncognitoImageContainer>
      <IncognitoImage src={eyeWithKeyholeSvg} data-name="incognito-cover" />
    </IncognitoImageContainer>
  )
}

const IncognitoImageContainer = styled.div`
  position: absolute;
  inset: 0;
  background-color: var(--rose-opacity-default);
`
const IncognitoImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: var(--spacing-96px);
  max-height: var(--spacing-96px);
  width: 100%;
  height: 100%;
`
